import React from "react";
import style from "./index.module.scss";
import { message, Modal, Tooltip } from "antd";
import ListStatus from "../ListStatus";
import ListStatics from "../ListStatics";
import ListDropDown from "../ListDropDown";
import { errorMessage } from "service/service";
import {
    QuestionMainListItem,
    QuestionStatus,
    removeQuestionnaire
} from "../../../../../service/question";
import useRequestFn from "../../../../../utils/useRequestFn";
import BriefInfo from "../BriefInfo";
import ListLinks from "../ListLinks";
import ViewPublishLog from "../ViewPublishLog";

interface ListItemProp {
    item: QuestionMainListItem;
    updateList: () => void;
    onSetting: (id: number) => void;
}

export default function ListItem({
    item,
    updateList,
    onSetting
}: ListItemProp) {
    const status =
        item.questionnaireCount < 1 && item.questionnaireStatus === 0
            ? QuestionStatus.NoChild
            : item.questionnaireStatus;
    const [removeAction] = useRequestFn(removeQuestionnaire);

    async function remove() {
        try {
            await removeAction(item.id);
            await updateList();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    function onDelete() {
        Modal.confirm({
            title: `删除“${item.description}”？`,
            content: "删除后不可恢复，确定要删除吗?",
            onOk: () => remove()
        });
    }

    return (
        <div className={style.root}>
            <h1 className={style.title}>
                <Tooltip title={item.description}>
                    {item.description}&nbsp;&nbsp;
                </Tooltip>
                <ListStatus state={status} />
            </h1>

            <div className={style.info}>
                {![QuestionStatus.NoChild, QuestionStatus.NotStarted].includes(
                    status
                ) && <ViewPublishLog id={item.id} />}
                <BriefInfo {...item} />
            </div>

            <div className={`${style.tools} `}>
                {status === QuestionStatus.done && (
                    <ListStatics
                        questionId={item.id}
                        allCount={item.questionnaireAllCount}
                        joinCount={item.joinInQuestionnaireCount}
                        noJoinCount={item.noJoinInQuestionnaireCount}
                    />
                )}

                <ListLinks status={status} id={item.id} reload={updateList} />

                <ListDropDown
                    id={item.id}
                    status={status}
                    onDelete={onDelete}
                    onSetting={onSetting}
                />
            </div>
        </div>
    );
}
